import { kNotNullOrUndefined } from "./kCoreHandler";
/** Pure readers for expanded OData collections; callers retain their gate/error policy. */
export class kCollectionRowsCore {
    /** DOCUMENTED EXCEPTION: pure data access; the optional envelope profile keeps repeated accessor reads. Caller owns faults. */
    public static Expanded = (Data: any, PreferArray: boolean = true, Profile: "Plain" | "RepeatedEnvelope" = "Plain"): any[] => {
        if (Profile === "RepeatedEnvelope") { return kCollectionRowsCore.RepeatedEnvelope(Data); }
        if (Data === null || Data === undefined) { return []; }
        if (PreferArray && Array.isArray(Data)) { return Data; }
        if (Array.isArray(Data.results)) { return Data.results; }
        if (Array.isArray(Data)) { return Data; }
        return [];
    };
    /** DOCUMENTED EXCEPTION: pure envelope projection; native getter faults and gate/error policy belong to the caller. */
    private static RepeatedEnvelope = (Data: any): any[] => {
        if (kNotNullOrUndefined(Data) === false) { return []; }
        if (kNotNullOrUndefined(Data.d) === true && Array.isArray(Data.d.results) === true) {
            return Data.d.results;
        }
        if (Array.isArray(Data.value) === true) { return Data.value; }
        return [];
    };
}
